import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsHelper {
  getJobTypeOptions(): Array<{ name: string; value: string; isSelected: boolean }> {
    return [
      { name: 'Grafički', value: 'Grafički', isSelected: false },
      { name: 'Inženjerski', value: 'Inženjerski', isSelected: false },
    ];
  }

  getUnitOptions(): Array<string> {
    return ['KOM', 'KOMPL', 'M', 'M2'];
  }

  getAdditionalServiceOptions(): Array<{ name: string; value: string; isSelected: boolean }> {
    return [
      { name: 'Servis', value: 'Servis', isSelected: false },
      { name: 'Gratis', value: 'Gratis', isSelected: false },
      { name: 'Reklamacija', value: 'Reklamacija', isSelected: false },
      { name: 'Dizajn', value: 'Dizajn', isSelected: false },
    ];
  }

  getProductCategoryOptions(): Array<{ name: string; value: string; isSelected: boolean }> {
    return [
      { name: 'Metal', value: 'Metal', isSelected: false },
      { name: 'Kartonaža', value: 'Kartonaža', isSelected: false },
      { name: 'Štampa', value: 'Štampa', isSelected: false },
      { name: 'Plastika', value: 'Plastika', isSelected: false },
      { name: 'Dorada', value: 'Dorada', isSelected: false },
    ];
  }

  getRequestTypeOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Standardan', value: 'Standardan' },
      { name: 'Nestandardan', value: 'Nestandardan' },
      { name: 'Trgovački', value: 'Trgovački' },
    ];
  }

  getRequestTypeWithSampleOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Standardan', value: 'Standardan' },
      { name: 'Nestandardan', value: 'Nestandardan' },
      { name: 'Uzorak', value: 'Uzorak' },
      { name: 'Trgovački', value: 'Trgovački' },
      { name: 'Reklamacija', value: 'Reklamacija' },
    ];
  }

  getDeliveryOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Isporuka', value: 'Isporuka' },
      { name: 'Montaža', value: 'Montaža' },
      { name: 'Isporuka i montaža', value: 'Isporuka i montaža' },
      { name: 'Slanje na lokacije', value: 'Slanje na lokacije' },
      { name: 'Preuzimanje', value: 'Preuzimanje' },
    ];
  }

  getZerothSampleOptions(): Array<string> {
    return [
      'Ne',
      'Da. Prvo uraditi jednu probu, pa nakon kontrole i odobrenja nastaviti produkciju',
      'Da. Prvo uraditi jednu tablu štampe i sečenja, pa nakon kontrole nastaviti produkciju',
      'Napomena. Prvo štampati i seći jedan plot, nakon provere kvaliteta nastaviti produkciju',
    ];
  }

  getDeliveryAddressUploadOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Unesi', value: 'text' },
      { name: 'Učitaj fajl', value: 'file' },
    ];
  }

  getWorkerCountOptions(): Array<number> {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  getShippingMethodOptions(): Array<string> {
    return ['Preuzima prevoznik', 'Preuzima montaža', 'Preuzima klijent', 'Slanje brzom poštom', 'Izvoz'];
  }

  getProductTypeOptions(): Array<string> {
    return ['Proizvod', 'Poluproizvod'];
  }

  getRequestListLinks(): Array<{ name: string; link: string; icon: string; method: string }> {
    return [
      { name: 'U pripremi', link: 'preparation', icon: 'inbox', method: 'getListOfWorkRequestsPreparation' },
      { name: 'U razvoju', link: 'development', icon: 'file-alt', method: 'getListOfWorkRequestsDevelopment' },
      { name: 'U tehnologiji', link: 'technology', icon: 'box', method: 'getListOfWorkRequestsTechnology' },
      { name: 'Obrađen za ponudu', link: 'for-offer', icon: 'file', method: 'getListOfWorkRequestsForOffer' },
      { name: 'Uzorci', link: 'sample', icon: 'boxes-stacked', method: 'getListOfWorkRequestsSample' },
      { name: 'Reklamacije', link: 'claim', icon: 'file-excel', method: 'getListOfWorkRequestsClaim' },
      { name: 'Poslato', link: 'sent-offers', icon: 'envelope-circle-check', method: 'getListOfWorkRequestsForOffer' },
      { name: 'Arhivirano', link: 'archived', icon: 'archive', method: 'getListOfWorkRequestsArchived' },
      { name: 'Ponude', link: 'offers', icon: 'handshake', method: 'getListOfWorkRequestsForOffer' },
      { name: 'Proizvodni prihodi', link: 'production-income', icon: 'bar-chart', method: 'getIncomeOverview' },
      { name: 'Neprihvaćeni poslovi', link: 'unaccepted-jobs', icon: 'file-circle-xmark', method: 'getListOfWorkRequestsUnacceptedJobs' },
      { name: 'Neprihvaćeni poslovi', link: 'unaccepted-jobs', icon: 'file-circle-xmark', method: 'getIncomeOverview' }, //TODO(BE): Remove this link
    ];
  }
}
